// =============================================================================
// Carloo Tex — Single Source of Truth for the app version.
//
// Bump this on **every** release so the version pill on Login + dashboards
// reflects what's actually deployed, and the server-side force-update flow
// (db.app_version) can compare against it.
//
// Versioning rules (semver-ish):
//   APP_VERSION       human-readable "MAJOR.MINOR.PATCH"
//   APP_VERSION_CODE  monotonically increasing integer derived from the
//                     version above:  major*10000 + minor*100 + patch
//                     => 2.0.0 -> 20000, 2.0.1 -> 20001, 2.1.0 -> 20100.
//
// Use the bump helper to keep both in sync:
//   bash /app/scripts/bump_version.sh patch    # 2.0.0 -> 2.0.1
//   bash /app/scripts/bump_version.sh minor    # 2.0.x -> 2.1.0
//   bash /app/scripts/bump_version.sh major    # 2.x.x -> 3.0.0
// =============================================================================
export const APP_VERSION = '2.6.4';
export const APP_VERSION_CODE = 20509;
// Compact pill text shown across the UI.
export const APP_VERSION_LABEL = `Ver ${APP_VERSION}`;
